import {Component} from '@angular/core';
import {DateHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {PersonWeitereAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

const identifikationsnummerLength = 11;

@Component({
  selector: 'common-ui-person-weitere-angaben',
  templateUrl: './person-weitere-angaben.component.html'
})
export class PersonWeitereAngabenComponent extends FormBaseComponent<PersonWeitereAngaben> {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }


  protected createForm(): void {
    this.form = this.formBuilder.group({
      geburtsdatum: [
        this.data.geburtsdatum,
        [
          this.validatorService.required(),
          this.validatorService.date(),
          this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.geburtsdatum),
            this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
        ]],
      identifikationsnummer: [
        this.data.identifikationsnummer,
        [
          this.validatorService.minLength(identifikationsnummerLength),
          this.validatorService.maxLength(identifikationsnummerLength)
        ]]
    });
  }
}
